export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/subscribers/getters.js